export default __webpack_public_path__ + "static/media/logo_animation.d2e16591.svg";